(function (global) {
  if (global.RandamuCampaignEnded) {
    global.RandamuCampaignEnded.hydrateRoots();
    return;
  }

  var CAMPAIGN_API_PREFIX = '/apps/campaign_proxy/api/proxy/campaigns/';
  var FUNDPOP_OBSERVE_MS = 15000;

  function isPastEnd(endMs, nowMs) {
    if (endMs == null || isNaN(endMs)) return false;
    var now = typeof nowMs === 'number' ? nowMs : Date.now();
    return now > endMs;
  }

  function hideCountdownBar(productId) {
    if (typeof document === 'undefined' || !productId) return;
    var bar = document.getElementById('CampaignCountdown-' + productId);
    if (!bar) return;
    bar.classList.add('hidden');
    bar.classList.remove('flex');
    bar.hidden = true;
    bar.setAttribute('aria-hidden', 'true');
  }

  function watchFundpop(root) {
    if (typeof document === 'undefined' || !root) return;
    var existing = root.querySelector('.fundpop-widget-container');
    if (existing) return;
    var obs = new MutationObserver(function () {
      var el = root.querySelector('.fundpop-widget-container');
      if (el) obs.disconnect();
    });
    obs.observe(root, { childList: true, subtree: true });
    var timer = setTimeout(function () {
      obs.disconnect();
    }, FUNDPOP_OBSERVE_MS);
    if (timer && typeof timer.unref === 'function') timer.unref();
  }

  function hideProgressEl(el) {
    if (!el) return;
    el.hidden = true;
    if (typeof el.setAttribute === 'function') {
      el.setAttribute('aria-hidden', 'true');
    }
    if (!el.style) return;
    if (typeof el.style.setProperty === 'function') {
      el.style.setProperty('display', 'none', 'important');
    } else {
      el.style.display = 'none';
    }
  }

  function progressNodes(scope) {
    if (!scope || typeof scope.querySelectorAll !== 'function') return [];
    return scope.querySelectorAll('.fundpop-product-card-progress');
  }

  function hideProductCardProgress(root) {
    if (!root) return;
    var card =
      (root.closest && (root.closest('product-card') || root.closest('.product-card'))) ||
      root.parentNode;
    if (card && typeof card.setAttribute === 'function') {
      card.setAttribute('data-campaign-ended', 'true');
    }
    var scope = card || root;
    var nodes = progressNodes(scope);
    for (var i = 0; i < nodes.length; i++) {
      hideProgressEl(nodes[i]);
    }
    if (typeof MutationObserver === 'undefined' || !scope || typeof scope.querySelectorAll !== 'function') {
      return;
    }
    var obs = new MutationObserver(function () {
      var found = progressNodes(scope);
      for (var j = 0; j < found.length; j++) {
        hideProgressEl(found[j]);
      }
    });
    obs.observe(scope, { childList: true, subtree: true });
    var timer = setTimeout(function () {
      obs.disconnect();
    }, FUNDPOP_OBSERVE_MS);
    if (timer && typeof timer.unref === 'function') timer.unref();
  }

  function setEnded(root) {
    if (!root) return;
    root.setAttribute('data-campaign-ended', 'true');
    var productId = root.getAttribute('data-product-id');
    hideCountdownBar(productId);
    hideProductCardProgress(root);
    watchFundpop(root);
  }

  var watchers = {};

  function watchEndTime(root, endMs) {
    if (!root || isNaN(endMs)) return;
    var productId = root.getAttribute('data-product-id') || String(endMs);
    if (watchers[productId]) {
      clearInterval(watchers[productId]);
    }
    function tick() {
      if (!isPastEnd(endMs)) return;
      setEnded(root);
      clearInterval(watchers[productId]);
      delete watchers[productId];
    }
    tick();
    if (root.getAttribute('data-campaign-ended') === 'true') return;
    watchers[productId] = setInterval(tick, 1000);
  }

  function campaignUrl(productId) {
    return CAMPAIGN_API_PREFIX + encodeURIComponent(String(productId));
  }

  async function loadEndMs(productId) {
    var apiCache = global.RandamuApiCache;
    if (!apiCache || typeof apiCache.getOrFetch !== 'function' || !productId) return NaN;
    try {
      var data = await apiCache.getOrFetch(
        campaignUrl(productId),
        async function () {
          var res = await fetch(campaignUrl(productId));
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        },
        {
          ttlMs: 2 * 60 * 60 * 1000,
          shouldCache: function (d) {
            return d != null && d.campaign != null;
          },
        }
      );
      var campaign = data && data.campaign;
      var endTime = campaign && campaign.endTime;
      var parsed = endTime ? new Date(endTime).getTime() : NaN;
      return parsed;
    } catch (e) {
      return NaN;
    }
  }

  async function hydrateRoot(root) {
    if (!root || root.getAttribute('data-campaign-ended') === 'true') return;
    var productId = root.getAttribute('data-product-id');
    var endMs = await loadEndMs(productId);
    if (isNaN(endMs)) return;
    watchEndTime(root, endMs);
  }

  var nearObserver = null;

  // Roots hydrate as they come near the screen, so the proxy calls for cards further down the
  // page stay out of its first paint. Without IntersectionObserver every root hydrates at once.
  function hydrateWhenNear(root) {
    if (typeof IntersectionObserver === 'undefined') {
      hydrateRoot(root);
      return;
    }
    nearObserver =
      nearObserver ||
      new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            nearObserver.unobserve(entries[i].target);
            hydrateRoot(entries[i].target);
          }
        },
        { rootMargin: '200px 0px' }
      );
    nearObserver.observe(root);
  }

  function hydrateRoots(scope) {
    if (typeof document === 'undefined') return;
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = root.querySelectorAll('[data-campaign-ended-root][data-product-id]');
    for (var i = 0; i < nodes.length; i++) {
      hydrateWhenNear(nodes[i]);
    }
  }

  var api = {
    isPastEnd: isPastEnd,
    setEnded: setEnded,
    watchEndTime: watchEndTime,
    hydrateRoots: hydrateRoots,
    loadEndMs: loadEndMs,
  };

  global.RandamuCampaignEnded = api;
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        hydrateRoots();
      });
    } else {
      hydrateRoots();
    }
  }
})(typeof window !== 'undefined' ? window : globalThis);
